import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  // model
  dashboardModel: {},
  adminNoticeModel: []
}

const getters = {
  get: state => state
}

const actions = {
  /**
   * ダッシュボーッド情報を読出し
   */
  loadDashboardData ({commit}, {dashboardParams, adminNoticeParams}) {
    return new Promise((resolve, reject) => {
      const isAdmin = this.getters['auth/isAdmin']

      const types = ['dashboard']
      const methods = ['v1DashboardGet']
      const parameters = [dashboardParams]

      if (isAdmin) {
        types.push('adminNotice')
        methods.push('v1AdminNoticeListGet')
        parameters.push(adminNoticeParams)
      }

      ApiManager.request(types, methods, parameters)
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setDashboardModel', res[0].data)
            console.log('dashboardModel', state.dashboardModel)

            if (isAdmin) {
              commit('setAdminNoticeModel', res[1].data.adminNotices)
              console.log('adminNoticeModel', state.adminNoticeModel)
            }
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  }
}

const mutations = {
  // model
  setDashboardModel (state, data) {
    // data.sort(Utility.sortByKey('CreatedAt', false))
    Vue.set(state, 'dashboardModel', data)
  },
  setAdminNoticeModel (state, data) {
    // data.sort(Utility.sortByKey('CreatedAt', false))
    Vue.set(state, 'adminNoticeModel', data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
